function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

export const onFileChange = (setter) => async (e) => {
  // return new Promise(async (resolve) => {
  //   setTimeout(async () => {
  //     if (e.target.files && e.target.files.length > 0) {
  //       const file = e.target.files[0];
  //       let imageDataUrl = await readFile(file);
  //       setter(imageDataUrl);
  //       resolve(imageDataUrl);
  //     }
  //   }, 100);
  // });

  // // TODO odkomentovat
  return new Promise((resolve, reject) => {
    try {
      const ajaxurl = window.GBCONF?.ajaxurl ?? '/wp-admin/admin-ajax.php';
      const nonce = window.GBCONF?.nonce ?? '';

      const file = e.currentTarget?.files?.[0] ?? e.target?.files?.[0];
      if (!file) return reject(new Error('No file selected'));

      const formData = new FormData();
      formData.append('action', 'gbc_upload_image');
      formData.append('nonce', nonce);
      formData.append('file', file);

      fetch(ajaxurl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.text()) // admin-ajax may return plain "0"
        .then((text) => {
          let data;
          try {
            data = JSON.parse(text);
          } catch {
            throw new Error(`Non-JSON response: ${text.slice(0, 200)}`);
          }

          if (data?.success && data?.data?.filename) {
            const url = `${window.location.origin}/wp-content/uploads/gbc_uploads/${data.data.filename}`;
            try {
              setter(url);
            } catch {}
            resolve(url);
          } else {
            throw new Error(data?.data || 'Upload failed');
          }
        })
        .catch(reject);
    } catch (err) {
      reject(err);
    }
  });
};

export const beforeCartUploadCropped = (image) => {
  return new Promise((resolve, reject) => {
    try {
      const ajaxurl = window.GBCONF?.ajaxurl ?? '/wp-admin/admin-ajax.php';
      const nonce = window.GBCONF?.nonce ?? '';

      if (!image) return reject(new Error('No file selected'));
      console.log(image);

      const formData = new FormData();
      formData.append('action', 'gbc_upload_image');
      formData.append('nonce', nonce);
      formData.append('file', image);

      fetch(ajaxurl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.text()) // admin-ajax may return plain "0"
        .then((text) => {
          let data;
          try {
            data = JSON.parse(text);
          } catch {
            throw new Error(`Non-JSON response: ${text.slice(0, 200)}`);
          }

          if (data?.success && data?.data?.filename) {
            const url = `${window.location.origin}/wp-content/uploads/gbc_uploads/${data.data.filename}`;
            resolve(url);
          } else {
            throw new Error(data?.data || 'Upload failed');
          }
        })
        .catch(reject);
    } catch (err) {
      reject(err);
    }
  });
};
